import { hasCapability, type User } from "../base";

export const projectCategory = {
  read: (user: User) => hasCapability(user, "projectCategory.read"),
};
